/**
 * @param {Record<string, unknown>} room
 */
export function mapFloorRoom(room) {
  return {
    id: room.id,
    name: room.short_name ?? room.name,
    fullName: room.full_name ?? room.fullName,
    status: room.status,
    guest: room.guest ?? null,
    therapist: room.therapist ?? null,
    service: room.service ?? null,
    serviceType: room.service_type ?? room.serviceType ?? null,
    duration: room.duration ?? null,
    remaining:
      room.remaining_min != null
        ? `${room.remaining_min} min`
        : (room.remaining ?? null),
    completesAt: room.completes_at ?? room.completesAt ?? null,
    occupancy: Number(room.occupancy_pct ?? room.occupancy ?? 0),
    nextBooking: room.next_booking ?? room.nextBooking ?? null,
    nextBookingTime: room.next_booking_time ?? room.nextBookingTime ?? null,
    prepStatus: room.prep_status ?? room.prepStatus ?? null,
    readiness: room.readiness ?? null,
  }
}

/**
 * @param {Record<string, unknown> | null | undefined} floor
 */
export function mapFloorStats(floor) {
  const stats = floor?.stats ?? {}

  return {
    occupied: stats.occupied_count ?? stats.occupied ?? 0,
    available: stats.available_count ?? stats.available ?? 0,
    turnover: stats.turnover_count ?? stats.turnover ?? 0,
    occupancyPct: stats.occupancy_pct ?? stats.occupancyPct ?? 0,
  }
}

/**
 * @param {Array<Record<string, unknown>> | undefined} rooms
 */
export function mapFloorRooms(rooms) {
  return (rooms ?? []).map(mapFloorRoom)
}
